import * as React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { Summary } from './analysis/summary/Summary';
import { AppRoutes } from './appRoutes';
import { AppWithAzureAuth } from './common/AppWithAzureAuth';
import { AppWithSidebarLayout } from './common/AppWithSidebarLayout';
import './override.css';
import { AppSettingsProvider } from './context/AppSettingsContext';
import { ExportSummaryPage } from './export-summary/components/ExportSummaryPage';
import { ExperimentOverview } from './overview/ExperimentOverview';
import { RepertoireAnalysisPage } from './repertoire-analysis/RepertoireAnalysisPage';

const DocumentationPage = React.lazy(() => import('./documentation/DocumentationPage'));
const TutorialsPage = React.lazy(() => import('./tutorials/TutorialsPage'));
const ProfilingPage = React.lazy(() => import('./profiling/ProfilingPage'));

export function App() {
  return (
    <AppSettingsProvider>
      <Router>
        <React.Suspense fallback={<div>Loading Application...</div>}>
          <Routes>
            <Route path="/" element={<AppWithAzureAuth />}>
              <Route path={AppRoutes.ExperimentOverview} element={<ExperimentOverview />} />
              <Route path={AppRoutes.Documentation} element={<DocumentationPage />} />
              <Route path={AppRoutes.Tutorials} element={<TutorialsPage />} />
              <Route path={AppRoutes.Profiling} element={<ProfilingPage />} />
              <Route path={AppRoutes.Experiment} element={<AppWithSidebarLayout />}>
                <Route path={AppRoutes.ExperimentDataOverview} element={<Summary />} />
                <Route path={AppRoutes.ExperimentRepertoireAnalysis} element={<RepertoireAnalysisPage />} />
                <Route path={AppRoutes.ExperimentClonotypeNetworkMap} element={<Navigate to={`../${AppRoutes.ExperimentAntibodyAnalysis}`} replace />} />
                {/* Hit Selection is mounted persistently by AppWithSidebarLayout
                    so its ECharts network graphs stay initialised across tab switches. */}
                <Route path={AppRoutes.ExperimentAntibodyAnalysis} element={null} />
                <Route path={AppRoutes.ExperimentExportSummary} element={<ExportSummaryPage />} />
                <Route path="*" element={<Navigate to={AppRoutes.ExperimentDataOverview} replace />} />
              </Route>

              <Route path="*" element={<Navigate to={AppRoutes.ExperimentOverview} replace />} />
            </Route>
          </Routes>
        </React.Suspense>
      </Router>
    </AppSettingsProvider>
  );
}
